import { GridColumnHeaderParams } from '@mui/x-data-grid-pro';
import { WhiteTooltip } from 'app/components/Common/Tooltips/WhiteTooltip';
import React from 'react';
const JobPreferenceNotificationHeaderRenderer = React.memo(function JobPreferenceNotificationHeaderRenderer(
  params: GridColumnHeaderParams,
) {
  return (
    <WhiteTooltip title={params.colDef.description}>
      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 500 }}>
        {params?.colDef.headerName}
      </div>
    </WhiteTooltip>
  );
});
export const JobPreferenceNotificationHeader = (params: GridColumnHeaderParams) => {
  return <JobPreferenceNotificationHeaderRenderer {...params} />;
};